var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 48.1001,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-90 0 48.1001)",
    fill: "#2A7EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5155 21.8883L23.1523 14.2515C23.6209 13.7829 24.3807 13.7829 24.8493 14.2515L32.4861 21.8883C32.9547 22.3569 32.9547 23.1167 32.4861 23.5853C32.0175 24.054 31.2577 24.054 30.789 23.5853L25.2008 17.9971V33.1C25.2008 33.7628 24.6636 34.3 24.0008 34.3C23.3381 34.3 22.8008 33.7628 22.8008 33.1V17.9971L17.2126 23.5853C16.744 24.054 15.9842 24.054 15.5155 23.5853C15.0469 23.1167 15.0469 22.3569 15.5155 21.8883Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopArrow);
export default __webpack_public_path__ + "static/media/top-arrow.f2a554ebc0d59cbffb2dc0ff41e12e67.svg";
export { ForwardRef as ReactComponent };